module.exports = __webpack_public_path__ + "img/wwf.e239699.png";